import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service'
import { ReviewService } from "../services/review.service";

import { fadeInUp } from '../services/animations/fadeInUp.animation'
import { timeout } from 'q';

@Component({
    selector: 'app-reviews',
    templateUrl: './reviews.component.html',
    animations: [fadeInUp]
})
export class ReviewsComponent implements OnInit {
    currentUser: any
    myReviews: Array<any> = []
    openedComment: Number = null
    isReviewsLoading: boolean = true

    constructor(
        private userService: UserService,
        private reviewService: ReviewService,
    ) {
    }

    ngOnInit() {
        // this.userService.getCurrentUser()
        this.userService.currentUser.subscribe((currentUser) => {
            this.currentUser = currentUser
            if (this.currentUser && this.currentUser._id) {
                this.getUserReviews()
            }
        })
    }

    getUserReviews() {
        const body = {
            userId: this.currentUser._id
        }
        this.reviewService.getUserReviews(body).then((result: Array<any>) => {
            this.myReviews = result.map(elm => {
                const newElm = elm
                newElm.provider = elm.provider[0]
                newElm.course = elm.course[0]
                return newElm
            })
            this.isReviewsLoading = false
        }).catch(err => {
            console.log(err);
        })
    }

    showComment(target: Number) {
        const elmsLink = document.getElementsByClassName('show-comment')
        const targetElmlink = document.getElementsByClassName('show-comment-' + target)
        const elms = document.getElementsByClassName('myreview__content')
        const targetElm = document.getElementsByClassName('myreview__content-' + target)
        for (var i = 0; i < elms.length; i++) {
            elmsLink[i].classList.remove('open');
            elms[i].classList.remove('open');
            elms[i]['style'].maxHeight = 0;
        }
        if (target !== this.openedComment) {
            targetElmlink[0].classList.add('open');
            targetElm[0].classList.add('open');
            targetElm[0]['style'].maxHeight = targetElm[0]['scrollHeight'] + 'px';
            this.openedComment = target
        } else {
            this.openedComment = null
        }
    }

    deleteReview() {
        // console.log('Delete Review');
    }

}



// WEBPACK FOOTER //
// ./src/app/user/reviews.component.ts